import { useState, useRef, useEffect } from "react";
import "../css/Blogs1.css";
import axios from 'axios';
//import BlogEditor from "./BlogEditor";

// ─── Seed data ───────────────────────────────────────────────────────────────
let _id = 9000;
const uid = () => ++_id;
let _bid = 5000;
const bid = () => `b${++_bid}`;

const CATEGORIES_SEED = [
  { id: 1, name: "Technology" },
  { id: 2, name: "Sustainability" },
  { id: 3, name: "Lifestyle" },
  { id: 4, name: "Innovation" },
];

const BLOGS_API = "/api/blogs";
const BLOG_CATEGORIES_API = "/api/blog-categories";

// Block shape: { id, type: 'heading'|'paragraph'|'image'|'quote', text, level, imageUrl, caption }
// `level` applies only to heading blocks ('h1'–'h6') and decides the rendered tag.
const BLOGS_SEED = [
  {
    id: 1,
    title: "Breaking Barriers: How System Orchestrators Are Driving Global Transformation",
    shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    coverImage: "https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=800&q=80",
    date: "2022-10-08",
    authorName: "Name of the Author",
    authorRole: "Senior Writer at Numeros Motors",
    authorBio: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.",
    authorAvatar: null,
    categoryIds: [1, 4],
    featured: true,
    summary: ["What Are System Orchestrators?", "Breaking Barriers to Drive Transformation", "Real-World Examples"],
    highlightedText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    contentBlocks: [
      { id: bid(), type: "heading", text: "What Are System Orchestrators?" },
      { id: bid(), type: "paragraph", text: "In a rapidly evolving world, the need for systemic change has never been more urgent. From combating climate change to addressing global health inequities, the challenges we face are interconnected and complex." },
      { id: bid(), type: "image", imageUrl: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=900&q=80", caption: "Teams coordinating across a complex system." },
      { id: bid(), type: "paragraph", text: "These challenges require more than isolated solutions; they demand orchestrated efforts that bring together diverse actors, resources, and ideas to drive lasting impact. This is where system orchestrators come into play." },
      { id: bid(), type: "quote", text: "System orchestrators are visionaries who see the bigger picture." },
      { id: bid(), type: "paragraph", text: "They are leaders, organizations, or networks that act as connectors, facilitators, and enablers within complex systems." },
    ],
    pullQuote: "If I take 30 steps linearly, I get to 30. If I take 30 steps exponentially, I get to a billion.",
    tags: ["Tag name 1", "Tag name 2", "Tag name 3", "Tag name 4"],
    readTime: 9,
  },
  {
    id: 2,
    title: "How Electric Scooters Are Reshaping Urban Commutes",
    shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.",
    coverImage: "https://images.unsplash.com/photo-1558981806-ec527fa84c39?w=800&q=80",
    date: "2022-10-08",
    authorName: "Name of the Author",
    authorRole: "Content Lead at Numeros Motors",
    authorBio: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.",
    authorAvatar: null,
    categoryIds: [2],
    featured: false,
    summary: ["Why cities are switching", "Cost comparison", "What's next"],
    highlightedText: "",
    contentBlocks: [
      { id: bid(), type: "paragraph", text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua." },
    ],
    pullQuote: "",
    tags: ["Tag name 1", "Tag name 2"],
    readTime: 6,
  },
  {
    id: 3,
    title: "Inside the Design Studio: Crafting the Diplos Max+",
    shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.",
    coverImage: "https://images.unsplash.com/photo-1601758228041-f3b2795255f1?w=800&q=80",
    date: "2022-09-21",
    authorName: "Name of the Author",
    authorRole: "Design Editor",
    authorBio: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.",
    authorAvatar: null,
    categoryIds: [3, 4],
    featured: false,
    summary: ["The brief", "Material choices", "Final reveal"],
    highlightedText: "",
    contentBlocks: [
      { id: bid(), type: "paragraph", text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua ut enim ad minim veniam." },
    ],
    pullQuote: "",
    tags: ["Tag name 1"],
    readTime: 5,
  },
  {
  id: 4,
  title: "Breaking Barriers: How System Orchestrators Are Driving Global Transformation",

  shortDescription:
    "In a rapidly evolving world, the need for systemic change has never been more urgent. From combating climate change to addressing global health inequities, the challenges we face are interconnected and complex.",

  coverImage:
    "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=1200&q=80",

  date: "2022-10-08",

  authorName: "Name of the Author",

  authorRole: "Senior Writer at Numeros Motors",

  authorBio:
    "Passionate about innovation, systems thinking, and sustainable transformation across industries.",

  authorAvatar: null,

  categoryIds: [1, 4],

  featured: true,

  summary: [
    "What Are System Orchestrators?",
    "Breaking Barriers to Drive Transformation",
    "Overcoming Fragmentation",
    "Bridging Sectors",
    "Scaling Innovations",
    "Building Trust",
    "Real-World Examples"
  ],

  highlightedText:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",

  contentBlocks: [
    {
      id: bid(),
      type: "heading",
      text: "Breaking Barriers: How System Orchestrators Are Driving Global Transformation",
      level: "h2"
    },

    {
      id: bid(),
      type: "paragraph",
      text:
        "In a rapidly evolving world, the need for systemic change has never been more urgent. From combating climate change to addressing global health inequities, the challenges we face are interconnected and complex."
    },

    {
      id: bid(),
      type: "paragraph",
      text:
        "These challenges require more than isolated solutions; they demand orchestrated efforts that bring together diverse actors, resources, and ideas to drive lasting impact. This is where system orchestrators come into play."
    },

    {
      id: bid(),
      type: "image",
      imageUrl:
        "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=1200&q=80",
      caption: "Systemic collaboration and transformation."
    },

    {
      id: bid(),
      type: "heading",
      text: "What Are System Orchestrators?",
      level: "h3"
    },

    {
      id: bid(),
      type: "paragraph",
      text:
        "System orchestrators are visionaries who see the bigger picture. They are leaders, organizations, or networks that act as connectors, facilitators, and enablers within complex systems."
    },

    {
      id: bid(),
      type: "paragraph",
      text:
        "Their role is to break down silos, foster collaboration, and align diverse stakeholders toward shared goals. Whether it's improving access to clean water, enhancing education systems, or accelerating renewable energy adoption, system orchestrators play a pivotal role in creating scalable and sustainable solutions."
    },

    {
      id: bid(),
      type: "image",
      imageUrl:
        "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&q=80",
      caption: "Collaboration across organizations."
    },

    {
      id: bid(),
      type: "quote",
      text:
        "One of the biggest barriers to systemic change is fragmentation. Organizations and individuals often work in isolation, leading to duplicated efforts and missed opportunities for collaboration."
    },

    {
      id: bid(),
      type: "heading",
      text: "Breaking Barriers to Drive Transformation",
      level: "h2"
    },

    {
      id: bid(),
      type: "heading",
      text: "Overcoming Fragmentation",
      level: "h3"
    },

    {
      id: bid(),
      type: "paragraph",
      text:
        "One of the biggest barriers to systemic change is fragmentation. Organizations and individuals often work in isolation, leading to duplicated efforts and missed opportunities for collaboration."
    },

    {
      id: bid(),
      type: "paragraph",
      text:
        "System orchestrators break this cycle by creating platforms for shared dialogue, resource pooling, and collective action."
    },

    {
      id: bid(),
      type: "heading",
      text: "Bridging Sectors",
      level: "h3"
    },

    {
      id: bid(),
      type: "paragraph",
      text:
        "Effective transformation requires cross-sector collaboration. System orchestrators bring together governments, private enterprises, non-profits, and communities to co-create solutions that are holistic and impactful."
    },

    {
      id: bid(),
      type: "paragraph",
      text:
        "For example, public-private partnerships in healthcare have led to breakthrough initiatives in vaccine distribution and accessibility."
    },

    {
      id: bid(),
      type: "heading",
      text: "Scaling Innovations",
      level: "h3"
    },

    {
      id: bid(),
      type: "paragraph",
      text:
        "While innovation is critical, its impact is limited without scale. System orchestrators identify high-potential innovations and create the conditions for them to reach broader audiences."
    },

    {
      id: bid(),
      type: "paragraph",
      text:
        "This includes securing funding, creating enabling policies, and building infrastructure for scale."
    },

    {
      id: bid(),
      type: "heading",
      text: "Building Trust",
      level: "h3"
    },

    {
      id: bid(),
      type: "paragraph",
      text:
        "Transformation is impossible without trust. System orchestrators invest in relationship-building and transparency, fostering environments where stakeholders feel valued and aligned in purpose."
    },

    {
      id: bid(),
      type: "quote",
      text:
        "If I take 30 steps linearly, I get to 30. If I take 30 steps exponentially, I get to a billion. Technology has advanced more in the last thirty years than in the previous two thousand. The exponential increase in advancement will only continue."
    },

    {
      id: bid(),
      type: "imageGroup",
      images: [
        {
          id: bid(),
          imageUrl:
            "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&q=80",
          altText: "Innovation"
        },
        {
          id: bid(),
          imageUrl:
            "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80",
          altText: "Collaboration"
        }
      ]
    },

    {
      id: bid(),
      type: "heading",
      text: "Real-World Examples",
      level: "h2"
    },

    {
      id: bid(),
      type: "paragraph",
      text:
        "United Nations Sustainable Development Goals (SDGs): The UN acts as a system orchestrator, aligning governments, NGOs, and private entities toward achieving global development targets."
    },

    {
      id: bid(),
      type: "paragraph",
      text:
        "UPI in India: India's Unified Payments Interface (UPI) showcases how orchestrating diverse stakeholders—banks, fintech companies, and regulators—can revolutionize financial inclusion at scale."
    },

    {
      id: bid(),
      type: "paragraph",
      text:
        "C40 Cities Climate Leadership Group: This network of cities collaborates to address climate change through shared knowledge and coordinated action."
    },

    {
      id: bid(),
      type: "imageGroup",
      images: [
        {
          id: bid(),
          imageUrl:
            "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
          altText: "UN SDGs"
        },
        {
          id: bid(),
          imageUrl:
            "https://images.unsplash.com/photo-1556740749-887f6717d7e4?w=800&q=80",
          altText: "UPI"
        },
        {
          id: bid(),
          imageUrl:
            "https://images.unsplash.com/photo-1497436072909-f5e4be5f1c5b?w=800&q=80",
          altText: "Climate Action"
        },
        {
          id: bid(),
          imageUrl:
            "https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?w=800&q=80",
          altText: "Sustainability"
        },
        {
          id: bid(),
          imageUrl:
            "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=800&q=80",
          altText: "Innovation"
        },
        {
          id: bid(),
          imageUrl:
            "https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=800&q=80",
          altText: "Partnerships"
        }
      ]
    }
  ],

  pullQuote:
    "If I take 30 steps linearly, I get to 30. If I take 30 steps exponentially, I get to a billion.",

  tags: [
    "Innovation",
    "Transformation",
    "Leadership",
    "Collaboration",
    "Sustainability",
    "Systems Thinking"
  ],

  readTime: 8
}
];

// ─── Heading levels ────────────────────────────────────────────────────────
// Supported rendered tags for heading blocks. `DEFAULT_HEADING_LEVEL` is used
// as a safe fallback for older blocks that never stored a `level`, so existing
// content is untouched and nothing breaks for legacy data.
const HEADING_LEVELS = ["h1", "h2", "h3", "h4", "h5", "h6"];
const DEFAULT_HEADING_LEVEL = "h2";
const normalizeHeadingLevel = (level) =>
  HEADING_LEVELS.includes(level) ? level : DEFAULT_HEADING_LEVEL;

const EMPTY_BLOCK = (type) => ({
  id: bid(),
  type,
  text: "",
  items: type === "list" ? [""] : undefined,
  imageUrl: null,
  caption: "",
  images: type === "imageGroup" ? [] : undefined, // ← new
  level: type === "heading" ? DEFAULT_HEADING_LEVEL : undefined, // ← heading tag
});

const EMPTY_BLOG_FORM = {
  title: "", shortDescription: "", date: "", authorName: "", authorRole: "", authorBio: "",
  categoryIds: [], featured: false,
  //summary: [""], 
  highlightedText: "",
  contentBlocks: [EMPTY_BLOCK("paragraph")],
  pullQuote: "", tags: [""],
};

// ─── Helpers ─────────────────────────────────────────────────────────────────
const wordCount = (txt = "") => txt.trim().split(/\s+/).filter(Boolean).length;
const readTimeFromText = (txt) => Math.max(1, Math.ceil(wordCount(txt) / 200));
const blocksToText = (blocks = []) =>
  blocks.filter((b) => b.type !== "image").map((b) => b.text || "").join(" ");
const readTimeFromBlocks = (blocks) => readTimeFromText(blocksToText(blocks));

const blockHasContent = (b) => {
  if (b.type === "image")      return !!b.imageUrl;
  if (b.type === "imageGroup") return b.images?.some((img) => !!img.imageUrl);
  if (b.type === "list") return b.items?.some(item => item.trim());
  return !!(b.text && b.text.trim());
};

const formatDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso + "T00:00:00");
  if (isNaN(d)) return iso;
  return d.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
};
const inp = (err) => `bl-input${err ? " bl-input-err" : ""}`;

// ═══════════════════════════════════════════════════════════════════════════
export default function Blogs() {
  const [categories, setCategories]   = useState([]);
  const [blogs, setBlogs]             = useState([]);
  const [newCategoryName, setNewCategoryName] = useState("");
  const [categoryError, setCategoryError]     = useState("");

  const [searchTerm, setSearchTerm]       = useState("");
  const [filterCategory, setFilterCategory] = useState("all");

  const [showModal, setShowModal] = useState(false);
  const [form, setForm]           = useState(EMPTY_BLOG_FORM);
  const [errors, setErrors]       = useState({});
  const [editId, setEditId]       = useState(null);
  const [deleteId, setDeleteId]   = useState(null);

  const [coverPreview, setCoverPreview]     = useState(null);
  const [coverImageFile, setCoverImageFile] = useState(null);
  const [avatarFile, setAvatarFile] = useState(null);
  const [avatarPreview, setAvatarPreview]   = useState(null);


  //fetch categories
  const fetchCategories = async () => {
  try {
    const res = await axios.get(BLOG_CATEGORIES_API);

    setCategories(res.data.data || []);
  } catch (err) {
    console.error("Failed to load categories", err);
  }
};


const fetchBlogs = async () => {
  try {
    const res = await axios.get(BLOGS_API);

    const transformed =
      (res.data.data || []).map((blog) => ({
        ...blog,

        categoryIds:
          blog.categories?.map((c) => c.id) || [],

        summary:
          Array.isArray(blog.summary)
            ? blog.summary
            : [],

        tags:
          Array.isArray(blog.tags)
            ? blog.tags
            : [],
      }));

    setBlogs(transformed);
  } catch (err) {
    console.error(err);
  }
};

useEffect(() => {
  fetchCategories();
  fetchBlogs();
}, []);

  // ── Categories ────────────────────────────────────────────────────────────
  const addCategory = async (autoSelect = false) => {
  const name = newCategoryName.trim();

  if (!name) return;

  try {
    const res = await axios.post(BLOG_CATEGORIES_API, {
      name,
      slug: name.toLowerCase().replace(/\s+/g, "-"),
    });

    const createdCategory = res.data.data;

    await fetchCategories();

    if (autoSelect) {
      setForm((f) => ({
        ...f,
        categoryIds: [...f.categoryIds, createdCategory.id],
      }));
    }

    setNewCategoryName("");
  } catch (err) {
    console.error(err);
  }
};

  const deleteCategory = async(id) => {
    const inUse = blogs.some((b) => b.categoryIds.includes(id));
    if (inUse) {
      setCategoryError("This category is used by existing blogs. Remove it from those blogs first.");
      setTimeout(() => setCategoryError(""), 4000);
      return;
    }
    //setCategories((c) => c.filter((cat) => cat.id !== id));
    await axios.delete(
  `${BLOG_CATEGORIES_API}/${id}`
   );
    await fetchCategories();
  };

  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState("");
  //upload to S3
   const uploadToS3 = async (file) => {

    if (!file) return null;
    setUploading(true);
    setUploadError("");
    try {
      //get signed url

      const { data } = await axios.post(
        "/api/assets/upload-url",
        {
           fileName: file.name,
           contentType: file.type
        }
      );

      const { uploadUrl, fileUrl } = data.data;

      //upload directly to S3

      await axios.put(
        uploadUrl, 
        file,
        {
          headers: {
            "Content-Type": file.type,
          },
        }
      );

     return fileUrl;

      //save cdn url into form state
      //onChange(field.key, fileUrl);
    } catch(error) {
        console.error(error);
        setUploadError(
          error?.response?.data?.message || "Upload failed"
        );
        return null;
    } finally {
      setUploading(false);
    }

     
  };

  // ── Blog form helpers ────────────────────────────────────────────────────
  const handleInput = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
    setErrors((err) => ({ ...err, [name]: "" }));
  };

  const toggleCategoryId = (id) => {
    setForm((f) => ({
      ...f,
      categoryIds: f.categoryIds.includes(id)
        ? f.categoryIds.filter((c) => c !== id)
        : [...f.categoryIds, id],
    }));
    setErrors((err) => ({ ...err, categoryIds: "" }));
  };

  const updateListItem = (key, i, val) => {
    setForm((f) => {
      const next = [...f[key]];
      next[i] = val;
      return { ...f, [key]: next };
    });
  };
  const addListItem = (key) => setForm((f) => ({ ...f, [key]: [...f[key], ""] }));
  const removeListItem = (key, i) =>
    setForm((f) => ({ ...f, [key]: f[key].filter((_, idx) => idx !== i) }));

  // ── Content block helpers ────────────────────────────────────────────────
  const addBlock = (type) => {
    setForm((f) => ({ ...f, contentBlocks: [...f.contentBlocks, EMPTY_BLOCK(type)] }));
    setErrors((err) => ({ ...err, bodyContent: "" }));
  };

  const insertBlock = (type, afterIndex) => {
    setForm((f) => {
      const blocks = [...f.contentBlocks];
      blocks.splice(afterIndex + 1, 0, EMPTY_BLOCK(type));
      return { ...f, contentBlocks: blocks };
    });
    setErrors((err) => ({ ...err, bodyContent: "" }));
  };

  const updateBlock = (id, patch) => {
    setForm((f) => ({
      ...f,
      contentBlocks: f.contentBlocks.map((b) => (b.id === id ? { ...b, ...patch } : b)),
    }));
    setErrors((err) => ({ ...err, bodyContent: "" }));
  };
  const removeBlock = (id) => {
    setForm((f) => ({ ...f, contentBlocks: f.contentBlocks.filter((b) => b.id !== id) }));
  };
  const moveBlock = (id, dir) => {
    setForm((f) => {
      const blocks = [...f.contentBlocks];
      const i = blocks.findIndex((b) => b.id === id);
      const j = dir === "up" ? i - 1 : i + 1;
      if (j < 0 || j >= blocks.length) return f;
      [blocks[i], blocks[j]] = [blocks[j], blocks[i]];
      return { ...f, contentBlocks: blocks };
    });
  };

  const openAdd = () => {
    setEditId(null);
    setForm(EMPTY_BLOG_FORM);
    setCoverPreview(null);
    setAvatarPreview(null);
    setErrors({});
    setShowModal(true);
  };

 const openEdit = (blog) => {
  setEditId(blog.id);

  setForm({
    title: blog.title || "",
    shortDescription: blog.shortDescription || "",
    date: blog.date || "",

    authorName: blog.authorName || "",
    authorRole: blog.authorRole || "",
    authorBio: blog.authorBio || "",

    categoryIds: blog.categoryIds || [],

    featured: !!blog.featured,

    // summary:
    //   blog.summary?.length
    //     ? blog.summary
    //     : [""],

    highlightedText:
      blog.highlightedText || "",

    contentBlocks:
      blog.contentBlocks?.length
        ? blog.contentBlocks
        : [EMPTY_BLOCK("paragraph")],

    pullQuote:
      blog.pullQuote || "",

    tags:
      blog.tags?.length
        ? blog.tags
        : [""],
  });

  setCoverPreview(blog.coverImage || null);
  setAvatarPreview(blog.authorAvatar || null);

  setCoverImageFile(null);

  setErrors({});
  setShowModal(true);
};

  const closeModal = () => {
    setShowModal(false);
    setForm(EMPTY_BLOG_FORM);
    setCoverPreview(null);
    setAvatarPreview(null);
     setCoverImageFile(null);
    setErrors({});
    setEditId(null);
  };


  const validate = () => {
    const e = {};
    if (!form.title.trim()) e.title = "Title is required.";
    if (!form.shortDescription.trim()) e.shortDescription = "Short description is required.";
    if (!editId && !coverPreview) e.coverImage = "Cover image is required.";
    if (!form.date) e.date = "Date is required.";
    if (!form.authorName.trim()) e.authorName = "Author name is required.";
    if (form.categoryIds.length === 0) e.categoryIds = "Select at least one category.";
    if (!form.contentBlocks.some(blockHasContent)) {
      e.bodyContent = "Add at least one paragraph, heading, or image to the body.";
    }
    return e;
  };

  const handleSubmit = async() => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }

    const cleanedBlocks = form.contentBlocks.filter(blockHasContent);

    let coverImageUrl = coverPreview;

   if (coverImageFile) {
  coverImageUrl = await uploadToS3(coverImageFile);
   }

   let avatarUrl = avatarPreview;

if (avatarFile) {
  avatarUrl = await uploadToS3(avatarFile);
}

   const processedBlocks = [];

for (const block of cleanedBlocks) {
  const newBlock = { ...block };

  // Single image block
  if (
    block.type === "image" &&
    block.imageFile
  ) {
    const uploadedUrl =
      await uploadToS3(block.imageFile);

    newBlock.imageUrl = uploadedUrl;

    delete newBlock.imageFile;
  }

  // Image group
  if (
    block.type === "imageGroup" &&
    Array.isArray(block.images)
  ) {
    const uploadedImages = [];

    for (const img of block.images) {
      const newImg = { ...img };

      if (img.imageFile) {
        const uploadedUrl =
          await uploadToS3(img.imageFile);

        newImg.imageUrl = uploadedUrl;

        delete newImg.imageFile;
      }

      uploadedImages.push(newImg);
    }

    newBlock.images = uploadedImages;
  }

  processedBlocks.push(newBlock);
}

   const slug = form.title
  .trim()
  .toLowerCase()
  .replace(/[^\w\s-]/g, "")
  .replace(/\s+/g, "-");

 const generatedSummary = processedBlocks
  .filter(
    (block) =>
      block.type === "heading" &&
      ["h1", "h2", "h3", "h4"].includes(block.level) &&
      block.text?.trim()
  )
  .map((block) => block.text.trim());

  console.log("Processed Blocks:", processedBlocks);

    const entry = {
      ...form,
      slug,
      coverImage: coverImageUrl,
      authorAvatar: avatarUrl,
      //summary: form.summary.filter((s) => s.trim()),
     summary: generatedSummary,
      tags: form.tags.filter((t) => t.trim()),
      contentBlocks: processedBlocks,
      readTime: readTimeFromBlocks(processedBlocks),
    };

    if (editId) {
      console.log("ENTRY", entry);
console.log("CONTENT BLOCKS", entry.contentBlocks);
      const res = await axios.put(
  `${BLOGS_API}/${editId}`,
  entry
);
console.log("edit res", res);
  const updatedBlog = {
    ...res.data.data,
    categoryIds: entry.categoryIds,
  };

  setBlogs((prev) => 
    prev.map((blog) => 
      blog.id === editId
      ? updatedBlog
      : blog
    )
  );


      //setBlogs((b) => b.map((bl) => bl.id === editId ? { ...bl, ...entry } : bl));
    } else {
      console.log("ENTRY", entry);
console.log("CONTENT BLOCKS", entry.contentBlocks);
      const res = await axios.post(
  BLOGS_API,
  entry
);
console.log("create res", res.data);
   const newBlog = {
    ...res.data.data,
    categoryIds: entry.categoryIds,
   };
   setBlogs((prev) => [newBlog, ...prev]);
      //setBlogs((b) => [...b, { id: uid(), ...entry }]);
    }
    closeModal();
  };

  const toggleFeatured = async (id) => {
  try {
    const blog = blogs.find(
      (b) => b.id === id
    );

    await axios.put(
      `${BLOGS_API}/${id}`,
      {
        ...blog,
        featured: !blog.featured,
      }
    );

    await fetchBlogs();
  } catch (err) {
    console.error(err);
  }
};

 const doDelete = async () => {
  try {
    await axios.delete(
      `${BLOGS_API}/${deleteId}`
    );

    setBlogs((prev) =>
      prev.filter(
        (blog) => blog.id !== deleteId
      )
    );

    setDeleteId(null);
  } catch (err) {
    console.error(err);
  }
};

  // ── Derived ──────────────────────────────────────────────────────────────
  const featuredBlogs = blogs.filter((b) => b.featured);
  const filteredBlogs = blogs.filter((b) => {
    if (filterCategory !== "all" && !b.categoryIds.includes(Number(filterCategory))) return false;
    if (searchTerm.trim() && !b.title.toLowerCase().includes(searchTerm.trim().toLowerCase())) return false;
    return true;
  });
  const liveReadTime = readTimeFromBlocks(form.contentBlocks);

  // ─── Render ────────────────────────────────────────────────────────────────
  return (
    <div className="bl-page">

      {/* Header */}
      <header className="bl-header">
        <div className="bl-title-group">
          <div className="bl-page-icon"><IconBlog /></div>
          <div>
            <h1 className="bl-page-title">Blogs</h1>
            <p className="bl-page-subtitle">
              {blogs.length} blog{blogs.length !== 1 ? "s" : ""} · {featuredBlogs.length} featured · {categories.length} categories
            </p>
          </div>
        </div>
        <button className="bl-btn-primary" onClick={openAdd}>+ Add Blog</button>
      </header>

      {/* Categories bar */}
      <section className="bl-categories-bar">
        <div className="bl-categories-left">
          <span className="bl-categories-label">Categories</span>
          <div className="bl-categories-chips">
            {categories.length === 0 && <span className="bl-cat-empty">No categories yet</span>}
            {categories.map((cat) => (
              <span className="bl-category-tag" key={cat.id}>
                {cat.name}
                <button onClick={() => deleteCategory(cat.id)} title="Remove category">✕</button>
              </span>
            ))}
          </div>
          {categoryError && <span className="bl-cat-error">{categoryError}</span>}
        </div>
        <div className="bl-categories-add">
          <input
            className="bl-cat-input"
            value={newCategoryName}
            onChange={(e) => setNewCategoryName(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && addCategory(false)}
            placeholder="New category name"
          />
          <button className="bl-btn-sm" onClick={() => addCategory(false)}>+ Add</button>
        </div>
      </section>

      {/* Content */}
      <main className="bl-content">

        {/* Featured Blogs */}
        <div className="bl-section-heading">
          <span>★ Featured Blogs</span>
          <span className="bl-section-count">{featuredBlogs.length}</span>
        </div>
        {featuredBlogs.length === 0 ? (
          <div className="bl-empty-strip">
            No featured blogs yet. Toggle a blog as <strong>Featured</strong> below to show it here.
          </div>
        ) : (
          <div className="bl-grid">
            {featuredBlogs.map((blog) => (
              <BlogCard key={blog.id} blog={blog} categories={categories}
                onEdit={openEdit} onDelete={setDeleteId} onToggleFeatured={toggleFeatured} />
            ))}
          </div>
        )}

        {/* All Blogs */}
        <div className="bl-section-heading bl-section-heading-spaced">
          <span>All Blogs</span>
          <span className="bl-section-count">{filteredBlogs.length}</span>
        </div>

        <div className="bl-filters">
          <input
            className="bl-search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search blogs by title…"
          />
          <select className="bl-filter-select" value={filterCategory}
            onChange={(e) => setFilterCategory(e.target.value)}>
            <option value="all">All Categories</option>
            {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
          {(searchTerm || filterCategory !== "all") && (
            <button className="bl-clear-filters" onClick={() => { setSearchTerm(""); setFilterCategory("all"); }}>
              Clear filters
            </button>
          )}
        </div>

        {filteredBlogs.length === 0 ? (
          <div className="bl-empty">
            <p>No blogs found.</p>
            <button className="bl-btn-primary" style={{ marginTop: 14 }} onClick={openAdd}>+ Add Blog</button>
          </div>
        ) : (
          <div className="bl-grid">
            {filteredBlogs.map((blog) => (
              <BlogCard key={blog.id} blog={blog} categories={categories}
                onEdit={openEdit} onDelete={setDeleteId} onToggleFeatured={toggleFeatured} />
            ))}
          </div>
        )}
      </main>

      {/* ════ ADD / EDIT BLOG MODAL ════ */}
      {showModal && (
        <div className="bl-backdrop" onClick={closeModal}>
          <div className="bl-modal" onClick={(e) => e.stopPropagation()}>
            <div className="bl-modal-header">
              <h2 className="bl-modal-title">{editId ? "Edit Blog" : "Add Blog"}</h2>
              <button className="bl-modal-close" onClick={closeModal}>✕</button>
            </div>

            <div className="bl-modal-body">

              {/* ── Section: Basic Details ── */}
              <div className="bl-section-label">Basic Details</div>

              <div className="bl-field">
                <label className="bl-label">Cover Image</label>
                <ImageDropzone preview={coverPreview} onFile={(file) => {setCoverImageFile(file); setCoverPreview(URL.createObjectURL(file));}}
                  onRemove={() => setCoverPreview(null)} error={errors.coverImage} />
              </div>

              <div className="bl-form-row">
                <Field label="Title" error={errors.title}>
                  <input className={inp(errors.title)} name="title" value={form.title}
                    onChange={handleInput} placeholder="Title of the blog" autoFocus />
                </Field>
                <Field label="Date" error={errors.date}>
                  <input className={inp(errors.date)} name="date" type="date" value={form.date}
                    onChange={handleInput} />
                </Field>
              </div>

              <Field label="Short Description" error={errors.shortDescription}>
                <textarea className={`bl-textarea${errors.shortDescription ? " bl-input-err" : ""}`}
                  name="shortDescription" value={form.shortDescription} onChange={handleInput}
                  rows={2} placeholder="A short summary shown on blog cards" />
              </Field>

              <div className="bl-form-row">
                <Field label="Author Name" error={errors.authorName}>
                  <input className={inp(errors.authorName)} name="authorName" value={form.authorName}
                    onChange={handleInput} placeholder="e.g. Jane Doe" />
                </Field>
                <Field label="Author Role">
                  <input className="bl-input" name="authorRole" value={form.authorRole}
                    onChange={handleInput} placeholder="e.g. Senior Writer at Numeros Motors" />
                </Field>
              </div>

              <Field label="Author Bio">
                <textarea className="bl-textarea" name="authorBio" value={form.authorBio}
                  onChange={handleInput} rows={2} placeholder="A short bio shown at the end of the article" />
              </Field>

              <div className="bl-field">
                <label className="bl-label">Author Photo <span className="bl-optional">(optional)</span></label>
                <ImageDropzone preview={avatarPreview} small
                  onFile={(file) => {
                      setAvatarFile(file);
                       setAvatarPreview(URL.createObjectURL(file));
                  }}
                  //onFile={(f) => f && setAvatarPreview(URL.createObjectURL(f))}
                  onRemove={() => setAvatarPreview(null)} />
              </div>

              {/* Categories */}
              <div className="bl-field">
                <label className="bl-label">Categories</label>
                <div className="bl-cat-select">
                  {categories.length === 0 && (
                    <span className="bl-cat-empty">No categories yet — add one below.</span>
                  )}
                  {categories.map((cat) => (
                    <button type="button" key={cat.id}
                      className={`bl-cat-chip${form.categoryIds.includes(cat.id) ? " bl-cat-chip-active" : ""}`}
                      onClick={() => toggleCategoryId(cat.id)}>
                      {cat.name}
                    </button>
                  ))}
                </div>
                <div className="bl-inline-add-cat">
                  <input className="bl-input" value={newCategoryName}
                    onChange={(e) => setNewCategoryName(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && addCategory(true)}
                    placeholder="Add a new category…" />
                  <button type="button" className="bl-btn-sm" onClick={() => addCategory(true)}>+ Add</button>
                </div>
                {errors.categoryIds && <span className="bl-err">{errors.categoryIds}</span>}
              </div>

              <div className="bl-featured-row">
                <ToggleSwitch checked={form.featured}
                  onChange={() => setForm((f) => ({ ...f, featured: !f.featured }))} />
                <div>
                  <div className="bl-featured-title">Show in Featured section</div>
                  <div className="bl-featured-sub">Featured blogs appear at the top of the blog page.</div>
                </div>
              </div>

              {/* ── Section: Article Content ── */}
              <div className="bl-section-label bl-section-label-spaced">Article Content</div>

              {/* <DynamicListField label="Summary (table of contents)" items={form.summary}
                placeholder="List item" onUpdate={(i, v) => updateListItem("summary", i, v)}
                onAdd={() => addListItem("summary")} onRemove={(i) => removeListItem("summary", i)} /> */}

              <Field label="Highlighted Callout Text">
                <textarea className="bl-textarea" name="highlightedText" value={form.highlightedText}
                  onChange={handleInput} rows={2}
                  placeholder="A short highlighted quote shown in a colored box near the top" />
              </Field>

              {/* Body content — Substack-style block editor */}
              <div className="bl-field">
                <label className="bl-label">Body Content</label>
                <ContentBlockEditor
                  blocks={form.contentBlocks}
                  onUpdate={updateBlock}
                  onRemove={removeBlock}
                  onMove={moveBlock}
                  onAdd={addBlock}
                  onInsert={insertBlock}
                />
                {/* <BlogEditor
                  content={form.bodyContent}
                  onChange={(html) =>
                    setForm((f) => ({
                      ...f,
                      bodyContent: html,
                    }))
                  }
                /> */}
                <div className="bl-readtime-badge">
                  <IconClock /> {liveReadTime} min read <span className="bl-readtime-note">(auto-calculated from content)</span>
                </div>
                {errors.bodyContent && <span className="bl-err">{errors.bodyContent}</span>}
              </div>

              <Field label="Pull Quote">
                <textarea className="bl-textarea" name="pullQuote" value={form.pullQuote}
                  onChange={handleInput} rows={2}
                  placeholder="A large highlighted quote shown mid-article (optional)" />
              </Field>

              <DynamicListField label="Tags" items={form.tags}
                placeholder="Tag name" onUpdate={(i, v) => updateListItem("tags", i, v)}
                onAdd={() => addListItem("tags")} onRemove={(i) => removeListItem("tags", i)} />
            </div>

            <div className="bl-modal-footer">
              <button className="bl-btn-ghost" onClick={closeModal}>Cancel</button>
              <button className="bl-btn-primary" onClick={handleSubmit}>
                {editId ? "Save Changes" : "Add Blog"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ════ DELETE CONFIRM ════ */}
      {deleteId && (
        <div className="bl-backdrop" onClick={() => setDeleteId(null)}>
          <div className="bl-confirm" onClick={(e) => e.stopPropagation()}>
            <div className="bl-confirm-icon"><IconTrash /></div>
            <h3 className="bl-confirm-title">Delete Blog?</h3>
            <p className="bl-confirm-msg">
              This will permanently remove{" "}
              <strong>{blogs.find((b) => b.id === deleteId)?.title}</strong>.
            </p>
            <div className="bl-confirm-actions">
              <button className="bl-btn-ghost" onClick={() => setDeleteId(null)}>Cancel</button>
              <button className="bl-btn-danger" onClick={doDelete}>Yes, Delete</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── Content Block Editor (Substack-style) ───────────────────────────────────
// Block type metadata
const BLOCK_META = {
  heading:    { label: "Heading",    icon: "H",  emoji: "H"  },
  paragraph:  { label: "Paragraph",  icon: "¶",  emoji: "¶"  },
  quote:      { label: "Quote",      icon: "❝",  emoji: "❝"  },
  list:       { label: "Bullet List", icon: "•", emoji: "•" },
  image:      { label: "Image",      icon: "🖼", emoji: "🖼" },
  imageGroup: { label: "Image Grid", icon: "⊞",  emoji: "⊞"  }, // ← new
};

export function ContentBlockEditor({ blocks, onUpdate, onRemove, onMove, onAdd, onInsert }) {
  if (blocks.length === 0) {
    return (
      <div className="bl-block-editor">
        <div className="bl-block-editor-empty">
          <p>No content blocks yet. Start by adding one below.</p>
          <AddBlockRow onAdd={onAdd} label="Add a block" />
        </div>
      </div>
    );
  }

  return (
    <div className="bl-block-editor">
      {blocks.map((block, i) => (
        <div key={block.id}>
          <ContentBlock
            block={block}
            index={i}
            total={blocks.length}
            isFirst={i === 0}
            isLast={i === blocks.length - 1}
            canDelete={blocks.length > 1}
            onUpdate={(patch) => onUpdate(block.id, patch)}
            onRemove={() => onRemove(block.id)}
            onMoveUp={() => onMove(block.id, "up")}
            onMoveDown={() => onMove(block.id, "down")}
          />
          {/* Between-block insert strip */}
          <InsertStrip onInsert={(type) => onInsert(type, i)} />
        </div>
      ))}

      {/* Final "add block" row */}
      <AddBlockRow onAdd={onAdd} label="Add block" />
    </div>
  );
}

function InsertStrip({ onInsert }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  // Close on outside click
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  return (
    <div className="bl-block-insert-strip">
      <div className="bl-block-insert-line" />
      <div className="bl-insert-menu-wrap" ref={ref}>
        <button
          type="button"
          className="bl-block-insert-btn"
          title="Insert block here"
          aria-label="Insert block here"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          +
        </button>
        {open && (
          <div className="bl-insert-menu" role="menu">
            {Object.entries(BLOCK_META).map(([type, meta]) => (
              <button
                type="button"
                key={type}
                className="bl-insert-menu-item"
                role="menuitem"
                onClick={() => { onInsert(type); setOpen(false); }}
              >
                <span className="bl-insert-menu-icon">{meta.icon}</span>
                {meta.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function ContentBlock({ block, index, total, isFirst, isLast, canDelete, onUpdate, onRemove, onMoveUp, onMoveDown }) {
  const meta = BLOCK_META[block.type] || BLOCK_META.paragraph;
  const positionLabel = total ? `${index + 1} / ${total}` : null;

  return (
    <div className={`bl-block bl-block-${block.type}`}>
      {/* Delete button — hover only, top-right */}
      <button
        type="button"
        className="bl-block-del"
        disabled={!canDelete}
        onClick={onRemove}
        title="Remove block"
        aria-label="Remove block"
      >
        ✕
      </button>

      <div className="bl-block-inner">
        {/* Reorder handle column */}
        <div className="bl-block-handle" title="Reorder">
          <button
            type="button"
            className="bl-handle-arrow"
            disabled={isFirst}
            onClick={onMoveUp}
            title="Move up"
            aria-label="Move block up"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M342.6 73.4C330.1 60.9 309.8 60.9 297.3 73.4L137.3 233.4C124.8 245.9 124.8 266.2 137.3 278.7C149.8 291.2 170.1 291.2 182.6 278.7L288 173.3L288 544C288 561.7 302.3 576 320 576C337.7 576 352 561.7 352 544L352 173.3L457.4 278.7C469.9 291.2 490.2 291.2 502.7 278.7C515.2 266.2 515.2 245.9 502.7 233.4L342.7 73.4z"/></svg>
          </button>
          {/* <div className="bl-handle-grip" aria-hidden="true">
            <span /><span /><span />
          </div> */}
          <button
            type="button"
            className="bl-handle-arrow"
            disabled={isLast}
            onClick={onMoveDown}
            title="Move down"
            aria-label="Move block down"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M297.4 566.6C309.9 579.1 330.2 579.1 342.7 566.6L502.7 406.6C515.2 394.1 515.2 373.8 502.7 361.3C490.2 348.8 469.9 348.8 457.4 361.3L352 466.7L352 96C352 78.3 337.7 64 320 64C302.3 64 288 78.3 288 96L288 466.7L182.6 361.3C170.1 348.8 149.8 348.8 137.3 361.3C124.8 373.8 124.8 394.1 137.3 406.6L297.3 566.6z"/></svg>
          </button>
        </div>

        {/* Content area */}
        <div className="bl-block-content">
          {/* Type badge */}
          <div className="bl-block-badge">
            <span className="bl-block-badge-dot" />
            {meta.label}
            {block.type === "heading" && (
              <span className="bl-block-badge-dot" style={{ background: "transparent" }} />
            )}
            {positionLabel && (
              <span style={{ marginLeft: "auto", color: "var(--grey-400)", fontWeight: 600 }}>
                {positionLabel}
              </span>
            )}
          </div>

          {/* Block-type-specific content */}
          {block.type === "heading" && (
            <div className="bl-block-heading-row" style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <select
                className="bl-select"
                style={{ width: "auto", minWidth: 72, flexShrink: 0, fontWeight: 700 }}
                value={normalizeHeadingLevel(block.level)}
                onChange={(e) => onUpdate({ level: e.target.value })}
                title="Heading level"
                aria-label="Heading level"
              >
                {HEADING_LEVELS.map((lvl) => (
                  <option key={lvl} value={lvl}>{lvl.toUpperCase()}</option>
                ))}
              </select>
              <input
                className="bl-input bl-block-heading-input"
                style={{ flex: 1, minWidth: 0 }}
                value={block.text}
                onChange={(e) => onUpdate({ text: e.target.value })}
                placeholder="Section heading…"
              />
            </div>
          )}

          {block.type === "paragraph" && (
            <textarea
              className="bl-textarea bl-block-paragraph-input"
              value={block.text}
              onChange={(e) => onUpdate({ text: e.target.value })}
              rows={4}
              placeholder="Write a paragraph…"
            />
          )}

          {block.type === "quote" && (
            <>
              <div className="bl-block-quote-mark">"</div>
              <textarea
                className="bl-textarea bl-block-quote-input"
                value={block.text}
                onChange={(e) => onUpdate({ text: e.target.value })}
                rows={2}
                placeholder="A short in-line quote…"
              />
            </>
          )}

          {block.type === "list" && (
  <div className="bl-list-editor">

    {block.items.map((item, index) => (
      <div
        key={index}
        className="bl-list-row"
      >
        <span>•</span>

        <input
          className="bl-input"
          value={item}
          placeholder="List item..."
          onChange={(e) => {
            const items = [...block.items];
            items[index] = e.target.value;
            onUpdate({ items });
          }}
        />

        <button
          type="button"
          className="bl-btn-danger"
          onClick={() => {
            const items = block.items.filter(
              (_, i) => i !== index
            );

            onUpdate({
              items:
                items.length
                  ? items
                  : [""],
            });
          }}
        >
          ✕
        </button>
      </div>
    ))}

    <button
      type="button"
      className="bl-btn-sm"
      onClick={() =>
        onUpdate({
          items: [...block.items, ""],
        })
      }
    >
      + Add Point
    </button>

  </div>
)}

          {block.type === "image" && (
            <div className="bl-block-image-layout">
              <ImageDropzone
                preview={block.imageUrl}
                small
                onFile={(f) => f && onUpdate({ imageUrl: URL.createObjectURL(f), imageFile: f, })}
                onRemove={() => onUpdate({ imageUrl: null })}
              />
              <div className="bl-block-caption-wrap">
                <span className="bl-block-caption-label">Caption</span>
                <input
                  className="bl-block-caption-input"
                  value={block.caption}
                  onChange={(e) => onUpdate({ caption: e.target.value })}
                  placeholder="Optional caption…"
                />
              </div>
            </div>
          )}

          {block.type === "imageGroup" && (
            <ImageGroupBlock
              images={block.images || []}
              onChange={(images) => onUpdate({ images })}
            />
          )}

        </div>
      </div>
    </div>
  );
}

function AddBlockRow({ onAdd, label }) {
  return (
    <div className="bl-block-add-row">
      <span className="bl-block-add-label">{label}:</span>
      {Object.entries(BLOCK_META).map(([type, meta]) => (
        <button
          type="button"
          key={type}
          className="bl-block-add-btn"
          onClick={() => onAdd(type)}
        >
          <span className="bl-block-add-icon">{meta.icon}</span>
          {meta.label}
        </button>
      ))}
    </div>
  );
}

// ─── Sub-components ───────────────────────────────────────────────────────────
function BlogCard({ blog, categories, onEdit, onDelete, onToggleFeatured }) {
  const catNames = blog.categoryIds
    .map((id) => categories.find((c) => c.id === id)?.name)
    .filter(Boolean);

  return (
    <article className="bl-card">
      <div className="bl-card-img-wrap">
        <img src={blog.coverImage} alt={blog.title} className="bl-card-img" />
        {blog.featured && <span className="bl-featured-badge">★ Featured</span>}
      </div>
      <div className="bl-card-body">
        <div className="bl-card-cats">
          {catNames.slice(0, 2).map((n) => <span key={n} className="bl-cat-pill">{n}</span>)}
        </div>
        <h3 className="bl-card-title">{blog.title}</h3>
        <p className="bl-card-desc">{blog.shortDescription}</p>
        <div className="bl-card-meta">
          <span><IconCalendar /> {formatDate(blog.date)}</span>
          <span><IconClock /> {blog.readTime} min read</span>
        </div>
        <div className="bl-card-author">By {blog.authorName}</div>
        <div className="bl-card-divider" />
        <div className="bl-card-footer">
          <ToggleSwitch checked={blog.featured} onChange={() => onToggleFeatured(blog.id)} label="Featured" small />
          <div className="bl-card-actions">
            <button className="bl-act-edit" onClick={() => onEdit(blog)}><IconEdit /> Edit</button>
            <button className="bl-act-del" onClick={() => onDelete(blog.id)}><IconTrash /> Delete</button>
          </div>
        </div>
      </div>
    </article>
  );
}

function ToggleSwitch({ checked, onChange, label, small }) {
  return (
    <label className={`bl-toggle${small ? " bl-toggle-sm" : ""}`}>
      <input type="checkbox" checked={checked} onChange={onChange} />
      <span className="bl-toggle-track"><span className="bl-toggle-thumb" /></span>
      {label && <span className="bl-toggle-label">{label}</span>}
    </label>
  );
}

function ImageDropzone({ preview, onFile, onRemove, error, small }) {
  const ref = useRef();
  const [dragging, setDragging] = useState(false);
  return (
    <div>
      <div
        className={`bl-dropzone${small ? " bl-dropzone-sm" : ""}${dragging ? " bl-dz-over" : ""}${error ? " bl-dz-err" : ""}`}
        onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
        onDragLeave={() => setDragging(false)}
        onDrop={(e) => { e.preventDefault(); setDragging(false); onFile(e.dataTransfer.files[0]); }}
        onClick={() => ref.current.click()}
      >
        {preview ? (
          <img src={preview} alt="preview" className="bl-dz-preview" />
        ) : (
          <div className="bl-dz-placeholder">
            <IconUpload />
            <span className="bl-dz-text">Click or drag to upload</span>
            <span className="bl-dz-hint">PNG, JPG, WEBP</span>
          </div>
        )}
        <input ref={ref} type="file" accept="image/*" style={{ display: "none" }}
          onChange={(e) => onFile(e.target.files[0])} />
      </div>
      {preview && <button type="button" className="bl-remove-img" onClick={onRemove}>Remove image</button>}
      {error && <span className="bl-err">{error}</span>}
    </div>
  );
}

function DynamicListField({ label, items, placeholder, onUpdate, onAdd, onRemove }) {
  return (
    <div className="bl-field">
      <label className="bl-label">{label}</label>
      {items.map((item, i) => (
        <div className="bl-tag-row" key={i}>
          <input className="bl-input" value={item} placeholder={`${placeholder} ${i + 1}`}
            onChange={(e) => onUpdate(i, e.target.value)} />
          {items.length > 1 && (
            <button type="button" className="bl-remove-tag" onClick={() => onRemove(i)}>✕</button>
          )}
        </div>
      ))}
      <button type="button" className="bl-add-tag-btn" onClick={onAdd}>+ Add another</button>
    </div>
  );
}

function Field({ label, error, children }) {
  return (
    <div className="bl-field">
      <label className="bl-label">{label}</label>
      {children}
      {error && <span className="bl-err">{error}</span>}
    </div>
  );
}

// ─── Icons ────────────────────────────────────────────────────────────────────
function IconBlog() {
  return <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="white" strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>;
}
function IconEdit() {
  return <svg width="12" height="12" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
  </svg>;
}
function IconTrash() {
  return <svg width="12" height="12" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
  </svg>;
}
function IconCalendar() {
  return <svg width="12" height="12" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>;
}
function IconClock() {
  return <svg width="12" height="12" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>;
}
function IconUpload() {
  return <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="#0a2ea0" strokeWidth="1.5">
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>;
}

// Empty image shape
const EMPTY_GROUP_IMAGE = () => ({ id: bid(), imageUrl: null, altText: "" });

function ImageGroupBlock({ images, onChange }) {
  const addImage   = () => onChange([...images, EMPTY_GROUP_IMAGE()]);
  const updateImage = (id, patch) =>
    onChange(images.map((img) => (img.id === id ? { ...img, ...patch } : img)));
  const removeImage = (id) => onChange(images.filter((img) => img.id !== id));

  return (
    <div>
      <div className="bl-image-group-grid">
        {images.map((img) => (
          <div key={img.id} className="bl-image-group-item">
            <ImageDropzone
              preview={img.imageUrl}
              small
              onFile={(f) => f && updateImage(img.id, { imageUrl: URL.createObjectURL(f), imageFile: f, })}
              onRemove={() => updateImage(img.id, { imageUrl: null })}
            />
            <input
              className="bl-block-caption-input"
              value={img.altText}
              onChange={(e) => updateImage(img.id, { altText: e.target.value })}
              placeholder="Alt text…"
              style={{ marginTop: 6 }}
            />
            <button type="button" className="bl-remove-img" onClick={() => removeImage(img.id)}>
              Remove
            </button>
          </div>
        ))}

        <button type="button" className="bl-add-image-tile" onClick={addImage}>
          <span style={{ fontSize: 18 }}>+</span>
          <span>Add image</span>
        </button>
      </div>
    </div>
  );
}
